import { render, staticRenderFns } from "./SidebarMinimizer.vue?vue&type=template&id=708b1bd1"
import script from "./SidebarMinimizer.vue?vue&type=script&lang=js"
export * from "./SidebarMinimizer.vue?vue&type=script&lang=js"
import style0 from "./SidebarMinimizer.vue?vue&type=style&index=0&id=708b1bd1&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/www-root/data/www/view.sessiondesign.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('708b1bd1')) {
      api.createRecord('708b1bd1', component.options)
    } else {
      api.reload('708b1bd1', component.options)
    }
    module.hot.accept("./SidebarMinimizer.vue?vue&type=template&id=708b1bd1", function () {
      api.rerender('708b1bd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/front/shared/components/coreui/SidebarMinimizer.vue"
export default component.exports